import { RuiReactComponentProps, replaceTextTokens } from '@roc-digital/rich-ui';

export function ParagraphElement(props: RuiReactComponentProps) {
  let content = props.node?.data?.html || '';
  content = replaceTextTokens(content, props.context.textTokens)
  return <div dangerouslySetInnerHTML={{__html: content}}></div>;
}
